import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/cal.com/apps/web/modules/apps/categories/categories-view.tsx");
